import type { UsageMetricName } from '@/graphql.types'

export type UsageMetricPointLike = {
  timestamp?: string | null
  value?: number | null
}

export type UsageMetricSeriesLike = {
  name?: UsageMetricName | null
  points?: ReadonlyArray<UsageMetricPointLike | null> | null
}

export type UsagePoint = {
  time: number
  value: number | null
}

export const getUsageSeriesPoints = (
  series: ReadonlyArray<UsageMetricSeriesLike | null> | null | undefined,
  name: UsageMetricName
): UsagePoint[] =>
  series
    ?.find((item) => item?.name === name)
    ?.points?.map((point) => ({
      time: new Date(point?.timestamp ?? '').getTime(),
      value: point?.value ?? null,
    })) ?? []

// Point-in-time reading of a series: the most recent point that carries a value.
// Returns null when the series is missing or has no data yet, so callers can
// render an unknown state instead of a misleading zero.
export const getLatestUsageValue = (
  series: ReadonlyArray<UsageMetricSeriesLike | null> | null | undefined,
  name: UsageMetricName
): number | null =>
  getUsageSeriesPoints(series, name)
    .filter((point) => point.value !== null)
    .at(-1)?.value ?? null
